var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvataricon08(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1251.3 1249.2",
    style: {
      enableBackground: "new 0 0 1251.3 1249.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6A632;}\n\t.st1{fill:#E73964;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#F4F4F4;}\n\t.st4{fill:#A8A8A8;}\n\t.st5{fill:url(#SVGID_00000075868130917378444230000010005670682460001714_);}\n\t.st6{fill:url(#SVGID_00000109720324931259864090000009414767599928835741_);}\n\t.st7{fill:url(#SVGID_00000063601556221197210210000005135288913356554911_);}\n\t.st8{fill:url(#SVGID_00000117640962226184731810000006871841649662080951_);}\n\t.st9{fill:#EAEAEA;}\n\t.st10{fill:#F9F7F7;}\n\t.st11{fill:#A0A0A0;}\n\t.st12{fill:url(#SVGID_00000155824922798247667940000007929452725940709289_);}\n\t.st13{fill:url(#SVGID_00000137850466964573443870000017729075019461972353_);}\n\t.st14{fill:url(#SVGID_00000138534769063570177920000017676002737702371762_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_00000112602046551431607490000010256302814744430209_);}\n\t.st17{fill:url(#SVGID_00000111188927372833333360000013265945052182577052_);}\n\t.st18{fill:url(#SVGID_00000122695330109967152820000001060617513257587600_);}\n\t.st19{fill:url(#SVGID_00000028299449117839982700000013969422346689586328_);}\n\t.st20{fill:url(#SVGID_00000071526640552381162210000015690754836681645967_);}\n\t.st21{fill:url(#SVGID_00000032610572575963535140000004873017250083804574_);}\n\t.st22{fill:url(#SVGID_00000110431793085791782040000005797282318666622604_);}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1251.3,
    height: 1249.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.5005,
    y1: 1038.5375,
    x2: 835.681,
    y2: 1038.5375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05779973,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1872,
    style: {
      stopColor: "#D4D4D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3108,
    style: {
      stopColor: "#ECECEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4253,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6449,
    style: {
      stopColor: "#FCFCFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8598,
    style: {
      stopColor: "#DFDFDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    style: {
      stopColor: "#C6C6C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M835.7,1120.2c-144.1-51-289.9-49.3-435.2,0V984c146.3-37.4,291.2-34.9,435.2,0V1120.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085953308234367129940000000555238194780829082_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.645,
    y1: 1276.0072,
    x2: 618.645,
    y2: 813.9417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#F0F0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9463,
    style: {
      stopColor: "#C1C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085953308234367129940000000555238194780829082_)"
    },
    d: "M770.7,866.5 c-11.3-0.1,5.5,141.6,32.4,180c28,40.2,208.1,91.4,296,119.9c49.4,16.1,70.4,82.7,70.4,82.7H67.9c0,0,50.4-57.5,69.2-70.4 c19.7-13.6,147.1-39.4,185-46.9c9.1-1.8,17.8-5.2,25.5-10.2c1.8-1.2,3.6-2.4,5.4-3.7l76.4-55.8c0,0,24-28.8,22-72.4 c-2-43.6,7.4-115.5,7.4-115.5L770.7,866.5z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.8,649.9c0,0-24.8-57.2-33.7-71.8c-8.9-14.6-5.2-83.9-10.5-115.3c-2-12.2-23.9-158.6,29.2-204.4 c53.1-45.8,84.1-58.3,84.1-58.3s2.2-18.7,50.9-18.7c48.7,0,7.1-31.2,86.6-18.7c79.5,12.5,95,12.5,95,12.5l17.7-2.1 c0,0,64.2,25,59.8,52.1c-4.4,27.1,43.4,9.6,43.4,9.6l15.7,23.6c0,0,52.8-1.5,39.3,141.6c-13.1,138.9-15.1,194.7-7.9,196.6 c17.1,4.6-40.4,24.9-40.4,24.9S829.4,371,758.6,373c-70.8,2-122.7,37.6-294.4,0C426.5,364.7,372.9,600,392.8,649.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387,738c0,0,30.5,149.4,107.2,195.7c119.7,72.4,202,11,202,11s95.5-85.5,111.2-135.9 c14-45,18.9-70.8,18.9-70.8s12.6,0,21-10.4s10.5-77,16.8-95.8c6.3-18.7,10.5-50-10.5-47.9c-21,2.1-31.5,37.5-31.5,37.5 s19.1-63,6.5-100.4c-12.6-37.5-4.4-116.1-54.8-147.3c-50.4-31.2-114.7-20.8-145.6-10.4c-30.9,10.4-96.1,4.2-136-10.4 c-39.9-14.6-73.6,54.1-79.9,85.4S384.9,596.4,387,621.4c2.1,25,2.1,25,2.1,25s-14.7-66.6-27.3-70.8c-12.6-4.2-35.7-4.2-31.5,45.8 c4.2,50,9.3,11.3,27.3,104.1C368.1,779.6,387,738,387,738z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M400.3,985c0,0-18.3,107.7-30.1,110.7c-11.7,3,130.2,72.8,182.4,79.6c0,0,31.4-54.2,66.5-70.6 C619.1,1104.6,407.5,1032.9,400.3,985z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M836.1,984c0,0,19.3,107.4,30.9,110.4c11.6,2.9-128,74.2-179.5,81.5c0,0-31.6-53.9-66.5-69.9 C621,1106,829.4,1032,836.1,984z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M710.4,835.1c-36.7-47.2-60.3-60.3-60.3-60.3s-57.7-10.5-89.1,0c-31.5,10.5-62.9,60.3-62.9,60.3 c0,47.2-7.9,97-7.9,97c31.5,31.5,73.4,39.3,118,39.3s99.6-31.5,102.2-36.7C713,929.4,710.4,835.1,710.4,835.1z M684.2,900.6 c-21.8,16.3-55,7.9-55,7.9c-18.3-2.6-5.2-44.6-5.2-44.6c-18.3,2.6-41.9,0-41.9,0s15.9,29.6-2.6,41.9c-15.7,10.5-49.8,2.6-57.7-5.2 c-15.7-15.7-7.9-55-7.9-55c15.7-13.1,21-15.7,55-26.2c34.1-10.5,68.2,0,68.2,0s51.6,13.2,55,23.6 C697.3,858.7,694.7,892.7,684.2,900.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvataricon08);
export default __webpack_public_path__ + "static/media/avatar icon-08.141f1cc6a50ccc246c765e910b21d365.svg";
export { ForwardRef as ReactComponent };